export default __webpack_public_path__ + "static/media/Avatar-19.b1f5236e.svg";